import { ItemMenu } from "../../../../questionnaire/pages/main/typing/types"
import { MenuOptionUserGroup } from "../utils/enums/menu"

export const formatFilterMain = {
  department: 'departments_ids',
  search: 'search',
  createYear: 'year',
  month: 'month',
  from: 'start_date',
  roles: 'role_ids',
  to: 'end_date',
  userId: 'user_ids',
  userTypeId: 'user_type_ids',
  divisions: 'division_ids',
  area: 'areas_ids',
}

export const menuItems: ItemMenu[] = [
  {
    label: 'Ver detalle',
    value: MenuOptionUserGroup.SEE_DETAIL,
  },
  {
    label: 'Editar',
    value: MenuOptionUserGroup.EDIT,
  },
  {
    label: 'Permisología',
    value: MenuOptionUserGroup.PERMISSIONS,
  },
  {
    label: 'Eliminar',
    value: MenuOptionUserGroup.DELETE,
  }
]